import { toIsoString } from '@peloton/time/formatters';
import { toTimeFromDate } from '@peloton/time/time';
import type { ActivityCalendarData } from './models/ActivityCalendarData';
import type { ApiActivityCalendar } from './models/ApiActivityCalendar';

const toDayIsoStrings = (days: number[], month: number, year: number): string[] =>
  days.map(day => toIsoString(toTimeFromDate(new Date(year, month - 1, day))));

export const toActivityCalendarData = (
  apiData: ApiActivityCalendar,
): ActivityCalendarData => {
  const activeDayHistory: string[] = [];
  const activeDayHistoryNonPartner3p: string[] = [];
  apiData.months.forEach(month => {
    activeDayHistory.push(...toDayIsoStrings(month.activeDays, month.month, month.year));
    activeDayHistoryNonPartner3p.push(
      ...toDayIsoStrings(month.daysActiveOnlyNonPartner3p ?? [], month.month, month.year),
    );
  });
  return { activeDayHistory, activeDayHistoryNonPartner3p };
};
